import { useState } from 'react';
import PageHero from '../../components/PageHero';
import './StaticPage.css';

const FAQ_ITEMS = [
  {
    q: 'How do I send an enquiry to a venue or vendor?',
    a: 'Open the venue or vendor profile and click "Enquire Now". Fill in your details and message; the business will receive your enquiry and can respond directly.',
  },
  {
    q: 'Is WeddingzVenue free to use?',
    a: 'Yes. Couples can search venues and vendors, view listings, and send enquiries at no cost. Venues and vendors may have subscription or listing fees.',
  },
  {
    q: 'How do I list my venue or business?',
    a: 'Go to "List Your Business" from the footer or register as a business. Complete the registration and profile steps to get your listing live.',
  },
  {
    q: 'Can I edit or cancel my enquiry?',
    a: 'Once sent, enquiries are delivered to the business. For changes or cancellation, please contact the venue or vendor directly or reach out to our support team.',
  },
  {
    q: 'How are venues and vendors verified?',
    a: 'We verify business details, contact information, and listings where possible. Always confirm pricing and availability directly with the business before booking.',
  },
  {
    q: 'Who do I contact for technical or account issues?',
    a: 'Email us at contact@weddingzvenue.in or use the Contact Us page. We typically respond within 1–2 business days.',
  },
];

function FAQPage() {
  const [openId, setOpenId] = useState(null);
  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <div className="static-page content-page">
      <PageHero
        title="Frequently Asked Questions"
        subtitle="Quick answers to common questions"
      />
      <div className="content-container">
        <ul className="faq-list">
          {FAQ_ITEMS.map((item, index) => (
            <li key={index} className={`faq-item ${openId === index ? 'open' : ''}`}>
              <button
                type="button"
                className="faq-question"
                onClick={() => toggle(index)}
                aria-expanded={openId === index}
              >
                {item.q}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              <div className="faq-answer">
                <p>{item.a}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default FAQPage;
